<div class="ec-algorithm-container">

    <!-- choose algorithm -->
    <div fxLayout="column" fxLayoutAlign="center" *ngIf="!isAlgorithmSelected">
        <div fxLayoutAlign="center" class="txt-h-24-7 mb-30">{{ 'Choose an amount redistribution algorithm'|i18n }}
        </div>
        <div fxLayout="row">
            <div fxFlex="13"></div>
            <div fxLayout="row wrap" fxLayoutAlign="space-around" class="mt-42">
                <button *ngIf="availableAlgorithms.includes(ALGORITHM_THOUSANDTH)"
                        fxLayout="column" fxLayoutAlign="space-around center"
                        [fxFlex]="availableAlgorithms.length > 3 ? 40 : 31"
                        (click)="onSelectAlgorithm(ALGORITHM_THOUSANDTH)" class="algorithm-button">
                    <app-icon name="fal-chart-pie" class="algorithm-icon"></app-icon>
                    <div fxFlex="25" class="txt-h-18-7 mt-16">{{ ALGORITHM_THOUSANDTH|redistributedAlgorithm|i18n }}</div>
                    <div fxFlex="50" class="txt-p-14-4 mt-16">
                        {{ 'Each member\'s incentive value (as consumer) is based on the condominium thousandth associated with his home.'|i18n }}
                    </div>
                </button>
                <button *ngIf="availableAlgorithms.includes(ALGORITHM_VAI)"
                        fxLayout="column" fxLayoutAlign="space-around center"
                        [fxFlex]="availableAlgorithms.length > 3 ? 40 : 31"
                        (click)="onSelectAlgorithm(ALGORITHM_VAI)" class="algorithm-button">
                    <app-icon name="fal-bullseye-arrow" class="algorithm-icon"></app-icon>
                    <div fxFlex="25" class="txt-h-18-7 mt-16">{{ ALGORITHM_VAI|redistributedAlgorithm|i18n }}</div>
                    <div fxFlex="50" class="txt-p-14-4 mt-16">
                        {{ 'Share the performance incentive according to the sharing that was actually achieved by individual members (POD).'|i18n }}
                    </div>
                </button>
                <button *ngIf="availableAlgorithms.includes(ALGORITHM_CAPPED_VAI)"
                        fxLayout="column" fxLayoutAlign="space-around center"
                        [fxFlex]="availableAlgorithms.length > 3 ? 40 : 31"
                        (click)="onSelectAlgorithm(ALGORITHM_CAPPED_VAI)" class="algorithm-button">
                    <app-icon name="fal-bullseye-arrow" class="algorithm-icon"></app-icon>
                    <div fxFlex="25" class="txt-h-18-7 mt-16">{{ ALGORITHM_CAPPED_VAI|redistributedAlgorithm|i18n }}</div>
                    <div fxFlex="50" class="txt-p-14-4 mt-16">
                        {{ 'Share the performance incentive according to the sharing that was actually achieved by individual members (POD).'|i18n }}
                    </div>
                </button>
                <button *ngIf="availableAlgorithms.includes(ALGORITHM_MIXED)"
                        fxLayout="column" fxLayoutAlign="space-around center"
                        [fxFlex]="availableAlgorithms.length > 3 ? 40 : 31"
                        (click)="onSelectAlgorithm(ALGORITHM_MIXED)" class="algorithm-button">
                    <app-icon name="fal-coins" class="algorithm-icon"></app-icon>
                    <div fxFlex="25" class="txt-h-18-7 mt-16">{{ ALGORITHM_MIXED|redistributedAlgorithm|i18n }}</div>
                    <div fxFlex="50" class="txt-p-14-4 mt-16">
                        {{ 'Assign incentive differently between members, combining fixed, variable amounts and eventually performance share.'|i18n }}
                    </div>
                </button>
                <button *ngIf="availableAlgorithms.includes(ALGORITHM_FANO)"
                        fxLayout="column" fxLayoutAlign="space-around center"
                        [fxFlex]="availableAlgorithms.length > 3 ? 40 : 31"
                        (click)="onSelectAlgorithm(ALGORITHM_FANO)" class="algorithm-button">
                    <app-icon name="fal-sack-dollar" class="algorithm-icon"></app-icon>
                    <div fxFlex="25" class="txt-h-18-7 mt-16">{{ ALGORITHM_FANO|redistributedAlgorithm|i18n }}</div>
                    <div fxFlex="50" class="txt-p-14-4 mt-16">
                        {{ 'Define shares for founding members and social fund and allocate based on the sharing performance made by individual users.'|i18n }}
                    </div>
                </button>
                <button *ngIf="availableAlgorithms.includes(ALGORITHM_CONDO_OLD)"
                        fxLayout="column" fxLayoutAlign="space-around center"
                        [fxFlex]="availableAlgorithms.length > 3 ? 40 : 31"
                        (click)="onSelectAlgorithm(ALGORITHM_CONDO_OLD)" class="algorithm-button">
                    <app-icon name="fal-users" class="algorithm-icon"></app-icon>
                    <div fxFlex="25" class="txt-h-18-7 mt-16">{{ ALGORITHM_CONDO_OLD|redistributedAlgorithm|i18n }}</div>
                    <div fxFlex="50" class="txt-p-14-4 mt-16">
                        {{ 'Configure fees and benefits (of owner members only) entirely by algorithm, based on energy sharing, self-consumption, and withdrawal.'|i18n }}
                    </div>
                </button>
            </div>
            <div fxFlex="13"></div>
        </div>
        <div fxLayoutAlign="center" class="mt-42">
            <button app-ghost-button (click)="onClickCancel()">
                {{ 'Cancel'|i18n }}
            </button>
        </div>
    </div>

    <form [formGroup]="form">

        <!-- ALGORITHM_VAI configuration -->
        <div *ngIf="chosenAlgorithm === ALGORITHM_VAI || chosenAlgorithm === ALGORITHM_CAPPED_VAI" fxLayout="column">
            <ng-container *ngTemplateOutlet="commonAlgorithmHeader"></ng-container>
            <div fxLayout="column" class="steps-panel template-background mt-30">
                <div class="txt-h-16-7 mb-10">{{ 'Amount determination for consumer member'|i18n }}</div>
                <div class="txt-s-16-4 mb-10">{{ 'The redistribution amount displayed in the table is relative only to consumer utilities and is intended to be understood as net.'|i18n }}</div>
                <div class="txt-s-16-4 mb-10">{{ 'The resulting amount for each POD is computed based on its energy contribution through absorption.'|i18n }}</div>
                <div *ngIf="chosenAlgorithm === ALGORITHM_CAPPED_VAI" class="txt-s-16-4 mb-10">
                    {{ 'Moreover, for each POD an incentive maximum threshold can be defined for the withdrawal of energy from the POD. When the threshold is reached, the exceeding incentive will be distributed over the remaining PODs.'|i18n }}
                </div>
                <div class="txt-s-16-4">{{ 'Additional parameters that indirectly define the amount assignable to the POD are:'|i18n }}</div>
                <ul>
                    <li class="txt-s-16-4 mb-4">{{ 'the consumer POD\'s time as "active" during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any change in the total number of active consumer POD during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any change in the POD\'s energy profile'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any changes made to the parameters of the algorithm itself during the selected period'|i18n }}</li>
                    <li *ngIf="chosenAlgorithm === ALGORITHM_CAPPED_VAI" class="txt-s-16-4 mb-4">
                        {{ 'a missing CAP threshold for a specific pod'|i18n }}
                    </li>
                    <li *ngIf="chosenAlgorithm === ALGORITHM_CAPPED_VAI" class="txt-s-16-4 mb-4">
                        {{ 'the redistribution of the amount that exceeds the CAP of a POD over the others'|i18n }}
                    </li>
                </ul>
                <div *ngIf="chosenAlgorithm === ALGORITHM_VAI" class="txt-p-16-4">
                    {{ 'To configure the redistribution amount, simply define a fixed part for all the consumer POD.'|i18n }}
                </div>
                <div *ngIf="chosenAlgorithm === ALGORITHM_VAI" class="txt-p-16-4">
                    {{ 'The remaining amount will be redistributed based on the sharing performance of each consumer POD.'|i18n }}
                </div>
                <div *ngIf="chosenAlgorithm === ALGORITHM_CAPPED_VAI" class="txt-p-16-4">
                    {{ 'To configure the allocation, simply define the fixed part of the amount and define a CAP threshold for each POD.'|i18n }}
                </div>
            </div>
            <div fxLayout="column" class="steps-background mt-30" fxLayoutGap="20px">

                <!-- step 1 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">1</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable" (click)="onClickGoToStep(1)">
                            {{ 'Enter fixed part'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 1">
                            <div class="txt-s-16-4 mt-10">{{ 'Divide a portion of the total net redistributable equally among all consumer POD.'|i18n }}</div>
                            <div fxLayout="row" fxLayoutAlign="center center" class="mt-30">
                                <div app-input-container fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px"
                                     class="txt-p-16-4">
                                    <div>{{ 'Percentage of total net redistributable:'|i18n }}</div>
                                    <input app-input
                                           type="number"
                                           formControlName="fixedPart"
                                           min="0"
                                           max="100"
                                           step="0.01"
                                           (input)="limitDecimals(form, 'fixedPart')"
                                           fxFlex="15">
                                    <div>{{ ('% of '|i18n) + (response.incentivation.redistributable_revenue|niceValue:'€':2) }}</div>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="center center" class="steps-panel">
                                    <div class="txt-s-16-7">{{ 'Fixed part'|i18n }}</div>
                                    <div class="txt-h-16-7">{{ getFixedPart()|niceValue:'€':2 }}</div>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutGap="10px" class="txt-s-16-4 mt-20">
                                <div>{{ 'Remaining amount to be redistributed on performance:'|i18n }}</div>
                                <div>{{ remainingAmount|niceValue:'€':2 }}</div>
                            </div>
                            <div fxLayoutAlign="end">
                                <button app-ghost-button [disabled]="!form.controls.fixedPart.valid"
                                        (click)="onClickNextStep()">
                                    <app-icon name="fal-arrow-down"></app-icon>
                                    {{ 'Next step'|i18n }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- step 2 -->
                <ng-container *ngTemplateOutlet="exceedingTip; context: { tipStep: 2 }"></ng-container>

                <!-- step 3 only for ALGORITHM_CAPPED_VAI -->
                <div *ngIf="chosenAlgorithm === ALGORITHM_CAPPED_VAI" fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">3</div>
                    <div fxLayout="column" class="steps-panel" fxFlex fxLayoutGap="10px">
                        <div class="txt-h-16-7 clickable"
                             (click)="onClickGoToStep(form.controls.fixedPart.valid ? 3 : null)">
                            {{ 'Define a CAP threshold for each consumer POD (optional)'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 3">
                            <div class="txt-s-16-4">
                                {{ 'Define a maximum contribution threshold that can be accumulated from each consumer POD.'|i18n }}
                            </div>
                            <div fxLayout="row" fxLayoutGap="20px" class="txt-p-16-4 mt-20">
                                <mat-slide-toggle formControlName="globalCapToggle" [checked]="enableCAP"
                                                  (change)="onCAPToggleEvent($event)" app-toggle
                                                  class="txt-p-16-4 mt-10">
                                </mat-slide-toggle>
                                <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px" fxFlex>
                                    <div app-input-container fxLayout="row" fxLayoutGap="10px"
                                         fxLayoutAlign="start center">
                                        <span [ngClass]="{'txt-p-16-4': enableCAP , 'txt-s-16-4': !enableCAP}">{{ 'Define a threshold for each POD:'|i18n }}</span>
                                        <input app-input
                                               type="number"
                                               formControlName="globalCap"
                                               min="0"
                                               max="100"
                                               step="0.01"
                                               (input)="limitDecimals(form, 'globalCap')"
                                               fxFlex="15"
                                               [readOnly]="!enableCAP"
                                               [disabled]="!enableCAP">
                                        <span [ngClass]="{'txt-p-16-4': enableCAP , 'txt-s-16-4': !enableCAP}">{{ '% of POD shared energy'|i18n }}</span>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="enableCAP"
                                         class="txt-s-16-4">
                                        {{ 'The CAP threshold will be applied to all PODs, overwriting any customizations made on them.'|i18n }}
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="enableCAP"
                                         class="txt-s-16-4">
                                        {{ 'If all PODs have a CAP threshold defined, their sum must be >=100'|i18n }}
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="!enableCAP"
                                         class="txt-s-16-4">
                                        {{ 'Any CAP thresholds placed on the PODs will not change.'|i18n }}
                                    </div>
                                </div>
                            </div>
                            <div fxLayoutAlign="end" class="mt-20">
                                <button app-ghost-button [disabled]="!validForm" (click)="onClickNextStep()">
                                    <app-icon name="fal-arrow-down"></app-icon>
                                    {{ 'Next step'|i18n }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- step 3 for ALGORITHM_VAI - OR - step 4 for ALGORITHM_CAPPED_VAI -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">{{ chosenAlgorithm === ALGORITHM_VAI ? 3 : 4 }}</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable"
                             (click)="onClickGoToStep(form.controls.fixedPart.valid ? (chosenAlgorithm === ALGORITHM_VAI ? 3 : 4) : null)">
                            {{ 'Apply the performance variable to the remaining part'|i18n }}
                        </div>
                        <ng-container *ngIf="chosenAlgorithm === ALGORITHM_VAI && step === 3 ||
                                             chosenAlgorithm === ALGORITHM_CAPPED_VAI && step === 4 ">
                            <div class="txt-s-16-4 mt-30">
                                {{ 'Amount intended for consumer utilities only, to be redistributed on performance:'|i18n }}
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" class="mt-50">
                                <div fxLayout="row" fxLayoutAlign="center center" fxFlex="30" class="steps-panel"
                                     fxLayoutGap="20px">
                                    <div fxFlex="50" class="txt-p-16-4  align-center">
                                        {{ 'Subtotal arranged for consumer group'|i18n }}
                                    </div>
                                    <app-icon name="fal-minus" class="algorithm-icon"></app-icon>
                                    <div class="txt-p-16-4">{{ 'Fixed part'|i18n }}</div>
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="txt-p-16-4 steps-panel align-center">
                                    {{ 'Member\'s sharing % based on CER total absorption'|i18n }}
                                </div>
                                <app-icon name="fal-equals" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="txt-p-16-4 steps-panel align-center">
                                    <b>{{ 'Individual share performance'|i18n }}</b>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <!-- save button -->
            <div fxLayout="row" fxLayoutAlign="end" class="mt-30">
                <button app-primary-button (click)="onClickSave()" fxFlex="10"
                        [disabled]="!validForm ||
                        chosenAlgorithm === ALGORITHM_VAI && step !== 3 ||
                        chosenAlgorithm === ALGORITHM_CAPPED_VAI && step !== 4">
                    {{ 'Save'|i18n }}
                </button>
            </div>
        </div>

        <!-- ALGORITHM_THOUSANDTH configuration -->
        <div *ngIf="chosenAlgorithm === ALGORITHM_THOUSANDTH" fxLayout="column" fxLayoutAlign="center">
            <ng-container *ngTemplateOutlet="commonAlgorithmHeader"></ng-container>
            <div fxLayout="column" class="steps-panel template-background mt-30">
                <div class="txt-h-16-7 mb-10">{{ 'Determination of the amount for each condominium member'|i18n }}</div>
                <div class="txt-s-16-4 mb-10">{{ 'The resulting amount for each member\'s POD is primarily based on his condominium thousandth.'|i18n }}</div>
                <div class="txt-s-16-4">{{ 'Additional parameters that indirectly define the amount assignable to the POD are:'|i18n }}</div>
                <ul>
                    <li class="txt-s-16-4 mb-4">{{ 'the POD\'s time as "active" during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any change in the total number of active POD during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any change in a POD\'s value in thousandths during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4">{{ 'the eventual sum of the thousandths configured as less than 1000'|i18n }}</li>
                </ul>
                <div class="txt-p-16-4">{{ 'To configure the redistribution, simply enter the thousandths of each condominium member through the Excel file below and upload the updated file.'|i18n }}</div>
            </div>
            <div class="txt-h-18-7 mt-64">{{ 'Configure values in thousandths'|i18n }}</div>
            <div fxLayout="column" class="steps-background mt-30" fxLayoutGap="20px">
                <!-- step 1 -->
                <ng-container *ngTemplateOutlet="exceedingTip; context: { tipStep: 1 }"></ng-container>

                <!-- step 2 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">2</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable"
                             (click)="onClickGoToStep(form.controls.setAsideTipUsage.valid ? 2 : null)">
                            {{ 'Configure values in thousandths through Excel'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 2">
                            <div fxLayout="column" fxLayoutAlign="center center" class="mt-36 ml-16 mb-24">
                                <div *ngIf="!templateDownloaded" fxLayout="column" fxLayoutAlign="center center"
                                     fxLayoutGap="30px"
                                     class="steps-background-thousandth">
                                    <app-icon name="fal-download" class="download-icon"></app-icon>
                                    <div class="txt-h-18-7">{{ '1. ' + ('Download and edit the Excel template'|i18n) }}</div>
                                    <button app-primary-button
                                            [disabled]="!isViewable(entity)"
                                            (click)="onClickDownloadThousandthsTemplate()">
                                        {{ 'Download template'|i18n }}
                                    </button>
                                </div>
                                <ng-container *ngIf="templateDownloaded">
                                    <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="30px"
                                         class="steps-background-thousandth mt-30">
                                        <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="30px">
                                            <app-icon fxLayoutAlign="center" name="fal-file"></app-icon>
                                            <span fxLayoutAlign="center"
                                                  class="txt-h-18-7">{{ '2. ' + ('Upload the edited Excel template'|i18n) }}</span>
                                            <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px">
                                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                                                    <span class="txt-p-16-4">{{ 'Edited file:'|i18n }}</span>
                                                    <input #fileSelect type="file" style="display: none"
                                                           [accept]="XLSX_MIME_TYPE"
                                                           (change)="onClickUploadTemplate($event)">
                                                    <button app-primary-button
                                                            [disabled]="!isUpdatable(entity)"
                                                            (click)="fileSelect.click()">
                                                        <app-icon
                                                                [name]="templateChosen ? 'fal-sync' : 'fal-search'"></app-icon>
                                                        {{ (templateChosen ? 'Change file' : 'Select file')|i18n }}
                                                    </button>
                                                    <span *ngIf="this.template?.name" class="txt-p-16-4">
                                                        {{ this.template?.name }}
                                                    </span>
                                                    <div *ngIf="!this.template.name" class="txt-s-14-4">
                                                        {{ 'No file uploaded'|i18n }}
                                                    </div>
                                                    <button *ngIf="templateChosen" app-icon-button
                                                            class="app-button-alert"
                                                            (click)="onClickTrashTemplate()">
                                                        <app-icon name="fal-trash-alt"></app-icon>
                                                    </button>
                                                </div>
                                                <span fxLayoutAlign="center center" class="txt-s-14-4">
                                                    {{ '(Max {0} MB. Accepts only XLSX files.)'|i18n:MAX_FILE_MB }}
                                                </span>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="center center">
                                            <div fxFlex="20"></div>
                                            <button app-ghost-button (click)="onClickCancel()" fxFlex="25">
                                                {{ 'Cancel'|i18n }}
                                            </button>
                                            <div fxFlex="10"></div>
                                            <button [disabled]="!templateChosen" app-primary-button
                                                    (click)="onClickSave()"
                                                    fxFlex="25">
                                                {{ 'Save'|i18n }}
                                            </button>
                                            <div fxFlex="20"></div>
                                        </div>
                                    </div>
                                    <span fxLayoutAlign="center center"
                                          class="txt-s-16-4 mt-30">{{ 'Do you want to download the template again?'|i18n }}</span>
                                    <div fxLayout="row" fxLayoutAlign="center center">
                                        <button app-ghost-button class="mt-20"
                                                (click)="onClickDownloadThousandthsTemplate()">
                                            <app-icon name="fas-download"></app-icon>
                                            <span>{{ 'Download template'|i18n }}</span>
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <!-- ALGORITHM_MIXED configuration -->
        <div *ngIf="chosenAlgorithm === ALGORITHM_MIXED" fxLayout="column" fxLayoutAlign="center">
            <ng-container *ngTemplateOutlet="commonAlgorithmHeader"></ng-container>
            <div fxLayout="column" class="steps-panel template-background mt-30">
                <div class="txt-h-16-7 mb-10">{{ 'Determination of the amount for each absorbing member'|i18n }}</div>
                <div class="txt-s-16-4 mb-10">{{ 'The redistribution amount displayed in the table is relative only to consumer utilities and is intended to be understood as net.'|i18n }}</div>
                <div class="txt-s-16-4 mb-10">{{ 'The resulting amount for each POD is calculated on the incentive amounts allocated in the various steps of the Excel configuration.'|i18n }}</div>
                <div class="txt-s-16-4">{{ 'Additional parameters that indirectly define the amount assignable to the POD are:'|i18n }}</div>
                <ul>
                    <li class="txt-s-16-4 mb-4">{{ 'the POD\'s time as "active" during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any change in the total number of active POD during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any change in a POD\'s energetic profile'|i18n }}</li>
                    <li class="txt-s-16-4">{{ 'eventual variations to the algorithm\'s parameters during the selected period'|i18n }}</li>
                </ul>
                <div class="txt-p-16-4">{{ 'To configure the redistribution through the Excel file, you have to:'|i18n }}</div>
                <ul>
                    <li class="txt-p-16-4 mb-4">{{ 'defined a fixed monthly amount'|i18n }}</li>
                    <li class="txt-p-16-4 mb-4">{{ 'redistribute the eventual remaining amount with fixed percentages for each POD'|i18n }}</li>
                    <li class="txt-p-16-4">{{ 'decide, for each POD, whether or not to allocate any additional allowance based on per capita sharing. This assignation has to be present of at least one utility.'|i18n }}</li>
                </ul>
            </div>

            <div fxLayout="column" class="steps-background mt-30" fxLayoutGap="20px">
                <!-- step 1 -->
                <ng-container *ngTemplateOutlet="exceedingTip; context: { tipStep: 1 }"></ng-container>

                <!-- step 2 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">2</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable"
                             (click)="onClickGoToStep(form.controls.setAsideTipUsage.valid ? 2 : null)">
                            {{ 'Configure the amounts through Excel'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 2">
                            <div fxLayout="column" fxLayoutAlign="center center" class="mt-36 ml-16 mb-24">
                                <div *ngIf="!templateDownloaded" fxLayout="column" fxLayoutAlign="center center"
                                     fxLayoutGap="30px"
                                     class="steps-background-thousandth">
                                    <app-icon name="fal-download" class="download-icon"></app-icon>
                                    <div class="txt-h-18-7">{{ '1. ' + ('Download and edit the Excel template'|i18n) }}</div>
                                    <button app-primary-button
                                            [disabled]="!isViewable(entity)"
                                            (click)="onClickDownloadMixedTemplate()">
                                        {{ 'Download template'|i18n }}
                                    </button>
                                </div>
                                <ng-container *ngIf="templateDownloaded">
                                    <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="30px"
                                         class="steps-background-thousandth mt-30">
                                        <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="30px">
                                            <app-icon fxLayoutAlign="center" name="fal-file"></app-icon>
                                            <span fxLayoutAlign="center"
                                                  class="txt-h-18-7">{{ '2. ' + ('Upload the edited Excel template'|i18n) }}</span>
                                            <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px">
                                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                                                    <span class="txt-p-16-4">{{ 'Edited file:'|i18n }}</span>
                                                    <input #fileSelect type="file" style="display: none"
                                                           [accept]="XLSX_MIME_TYPE"
                                                           (change)="onClickUploadTemplate($event)">
                                                    <button app-primary-button
                                                            [disabled]="!isUpdatable(entity)"
                                                            (click)="fileSelect.click()">
                                                        <app-icon
                                                                [name]="templateChosen ? 'fal-sync' : 'fal-search'"></app-icon>
                                                        {{ (templateChosen ? 'Change file' : 'Select file')|i18n }}
                                                    </button>
                                                    <span *ngIf="this.template?.name" class="txt-p-16-4">
                                                        {{ this.template?.name }}
                                                    </span>
                                                    <div *ngIf="!this.template.name" class="txt-s-14-4">
                                                        {{ 'No file uploaded'|i18n }}
                                                    </div>
                                                    <button *ngIf="templateChosen" app-icon-button
                                                            class="app-button-alert"
                                                            (click)="onClickTrashTemplate()">
                                                        <app-icon name="fal-trash-alt"></app-icon>
                                                    </button>
                                                </div>
                                                <span fxLayoutAlign="center center" class="txt-s-14-4">
                                                    {{ '(Max {0} MB. Accepts only XLSX files.)'|i18n:MAX_FILE_MB }}
                                                </span>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="center center">
                                            <div fxFlex="20"></div>
                                            <button app-ghost-button (click)="onClickCancel()" fxFlex="25">
                                                {{ 'Cancel'|i18n }}
                                            </button>
                                            <div fxFlex="10"></div>
                                            <button [disabled]="!templateChosen" app-primary-button
                                                    (click)="onClickSave()"
                                                    fxFlex="25">
                                                {{ 'Save'|i18n }}
                                            </button>
                                            <div fxFlex="20"></div>
                                        </div>
                                    </div>
                                    <span fxLayoutAlign="center center"
                                          class="txt-s-16-4 mt-30">{{ 'Do you want to download the template again?'|i18n }}</span>
                                    <div fxLayout="row" fxLayoutAlign="center center">
                                        <button app-ghost-button class="mt-20"
                                                (click)="onClickDownloadMixedTemplate()">
                                            <app-icon name="fas-download"></app-icon>
                                            <span>{{ 'Download template'|i18n }}</span>
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <!-- ALGORITHM_FANO configuration -->
        <div *ngIf="chosenAlgorithm === ALGORITHM_FANO" fxLayout="column" fxLayoutAlign="center">
            <ng-container *ngTemplateOutlet="commonAlgorithmHeader"></ng-container>
            <div fxLayout="column" class="steps-panel template-background mt-30">
                <div class="txt-h-16-7 mb-10">{{ 'Amount determination for consumer member'|i18n }}</div>
                <div class="txt-s-16-4 mb-10">{{ 'The redistribution amount displayed in the table is relative only to consumer utilities and is intended to be understood as net.'|i18n }}</div>
                <div class="txt-s-16-4">{{ 'Additional parameters that indirectly define the amount assignable to the POD are:'|i18n }}</div>
                <ul>
                    <li class="txt-s-16-4 mb-4">{{ 'the consumer POD\'s time as "active" during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any change in the total number of active consumer POD during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any change in the POD\'s energy profile'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any changes made to the parameters of the algorithm itself during the selected period'|i18n }}</li>
                </ul>
                <div class="txt-s-16-4 mt-10">{{ 'To configure the redistribution of the amount, simply define the individual percentages to be applied to the total net incentive.'|i18n }}</div>
                <div class="txt-s-16-4 mt-4">{{ 'The share due to consumer members will be redistributed according to the monthly consumption of each consumer POD.'|i18n }}</div>
            </div>

            <div *ngIf="showFanoWarning === null" fxLayout="column" fxLayoutAlign="space-around center">
                <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
                    <mat-spinner app-spinner diameter="20"></mat-spinner>
                    <span class="pl-8">{{ 'Loading'|i18n }}...</span>
                </div>
            </div>

            <div *ngIf="showFanoWarning" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px"
                 economics-warning class="mt-30 padding-14">
                <app-icon icon-color-w name="fas-info-circle"></app-icon>
                <div fxLayout="column">
                    <div>{{ 'In order to configure the "Founding members and fund with daytime hours" algorithm, the CACV must be split between plants and consumer utilities in the same way as TIP.'|i18n }}</div>
                    <div>{{ 'It is necessary that for each plant the criterion used to allocate a share of the premium rate is the net TIP, the chosen redistribution parameter is the percentage of the net TIP, and the value of the percentage is the same for all plants in the community.'|i18n }}</div>
                </div>
            </div>

            <div *ngIf="showFanoWarning !== null && allowFanoConfiguration" fxLayout="column" class="steps-background mt-30"
                 fxLayoutGap="20px">
                <!-- step 1 -->
                <ng-container *ngTemplateOutlet="exceedingTip; context: { tipStep: 1 }"></ng-container>

                <!-- step 2 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">2</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable" (click)="onClickGoToStep(2)">
                            {{ 'Percentage of net incentive allocated to founding members'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 2">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-16-4 mt-30">
                                <div>{{ 'Enter percentage'|i18n }}:</div>
                                <div app-input-container>
                                    <input app-input
                                           type="number"
                                           formControlName="foundersPercentage"
                                           min="0"
                                           max="100"
                                           step="0.01"
                                           (input)="limitDecimals(form, 'foundersPercentage')">
                                    <div *ngIf="form.hasError('tooMuch')" app-error>
                                        {{ tooMuchErrorMessage }}
                                    </div>
                                </div>
                                <div>{{ ('% of '|i18n) + (fanoNetIncentive|niceValue:'€':2) }}</div>
                            </div>
                            <div fxLayoutAlign="end">
                                <button app-ghost-button [disabled]="!form.controls.foundersPercentage.valid" (click)="onClickNextStep()">
                                    <app-icon name="fal-arrow-down"></app-icon>
                                    {{ 'Next step'|i18n }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- step 3 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">3</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable" (click)="onClickGoToStep(3)">
                            {{ 'Percentage of net incentive allocated to social fund'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 3">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-16-4 mt-30">
                                <div>{{ 'Enter percentage'|i18n }}:</div>
                                <div app-input-container>
                                    <input app-input
                                           type="number"
                                           formControlName="socialFundPercentage"
                                           min="0"
                                           max="100"
                                           step="0.01"
                                           (input)="limitDecimals(form, 'socialFundPercentage')">
                                    <div *ngIf="form.hasError('tooMuch')" app-error>
                                        {{ tooMuchErrorMessage }}
                                    </div>
                                </div>
                                <div>{{ ('% of '|i18n) + (fanoNetIncentive|niceValue:'€':2) }}</div>
                            </div>
                            <div fxLayoutAlign="end">
                                <button app-ghost-button [disabled]="!form.controls.socialFundPercentage.valid" (click)="onClickNextStep()">
                                    <app-icon name="fal-arrow-down"></app-icon>
                                    {{ 'Next step'|i18n }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- step 4 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">4</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable" (click)="onClickGoToStep(form.controls.socialFundPercentage.valid ? 4 : null)">
                            {{ 'Apply the performance variable to the remaining part'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 4">
                            <div class="txt-s-16-4 mt-30">
                                {{ 'Amount intended for consumer utilities only, to be redistributed on performance:'|i18n }}
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" class="mt-50">
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Subtotal remaining from previous steps'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="txt-p-16-4 steps-panel align-center">
                                    {{ 'Member\'s consumption % of total CER consumption in hours 8-18, on a monthly basis'|i18n }}
                                </div>
                                <app-icon name="fal-equals" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="txt-p-16-4 steps-panel align-center">
                                    <b>{{ 'Individual share performance'|i18n }}</b>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <!-- save button -->
            <div fxLayout="row" fxLayoutAlign="end" class="mt-30">
                <button app-primary-button (click)="onClickSave()" fxFlex="10"
                        [disabled]="!validForm ||
                        chosenAlgorithm === ALGORITHM_FANO && step !== 4">
                    {{ 'Save'|i18n }}
                </button>
            </div>
        </div>

        <!-- ALGORITHM_CONDO_OLD configuration -->
        <div *ngIf="chosenAlgorithm === ALGORITHM_CONDO_OLD" fxLayout="column" fxLayoutAlign="center">
            <ng-container *ngTemplateOutlet="commonAlgorithmHeader"></ng-container>
            <div fxLayout="column" class="steps-panel template-background mt-30">
                <div class="txt-h-16-7 mb-10">{{ 'Amount determination for owner consumer member'|i18n }}</div>
                <div class="txt-s-16-4 mb-10">{{ 'The redistribution amount displayed in the table is relative only to holder consumer utilities'|i18n }}</div>
                <div class="txt-s-16-4">{{ 'Additional parameters that indirectly define the amount assignable to the POD are:'|i18n }}</div>
                <ul>
                    <li class="txt-s-16-4 mb-4">{{ 'the consumer POD\'s time as "active" during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any change in the total number of active consumer POD during the selected period'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any change in the POD\'s energy profile'|i18n }}</li>
                    <li class="txt-s-16-4 mb-4">{{ 'any changes made to the parameters of the algorithm itself during the selected period'|i18n }}</li>
                </ul>
                <div class="txt-s-16-4 mt-10">{{ 'To configure the redistribution of the amount, it is sufficient to define the fee and benefit quotas per individual POD, defined according to the respective economic components.'|i18n }}</div>
            </div>

            <div fxLayout="column" class="steps-background mt-30" fxLayoutGap="20px">


                <!-- step 1 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">1</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable" (click)="onClickGoToStep(1)">
                            {{ 'Define contractual fee on energy sharing (TIP)'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 1">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-16-4 mt-30">
                                <div>{{ 'Fee specified in contract'|i18n }}:</div>
                                <div app-input-container fxFlex="10">
                                    <input app-input
                                           type="number"
                                           formControlName="tipFee"
                                           min="0"
                                           max="1000"
                                           step="0.01"
                                           (input)="limitDecimals(form, 'tipFee')">
                                </div>
                                <div>{{ '€/MWh of shared energy'|i18n }}</div>
                            </div>
                            <div class="txt-s-14-4 mt-10">
                                {{ 'Fee that the individual POD pays to the community manager.'|i18n }}
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" class="mt-50 mb-10">
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ '% of individual absorption on total absorption'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Total shared energy in MWh'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Fee in €/MWh indicated per contract'|i18n }}
                                </div>
                                <app-icon name="fal-equals" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="txt-p-16-4 steps-panel align-center">
                                    <b>{{ 'Fee'|i18n }}</b>
                                </div>
                            </div>

                            <div fxLayoutAlign="end">
                                <button app-ghost-button [disabled]="!form.controls.tipFee.valid" (click)="onClickNextStep()">
                                    <app-icon name="fal-arrow-down"></app-icon>
                                    {{ 'Next step'|i18n }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- step 2 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">2</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable" (click)="goToStepIfValid(2, 'tipFee')">
                            {{ 'Define contractual fee on energy withdrawal'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 2">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-16-4 mt-30">
                                <div>{{ 'Fee specified in contract'|i18n }}:</div>
                                <div app-input-container fxFlex="10">
                                    <input app-input
                                           type="number"
                                           formControlName="withdrawalFeePercent"
                                           min="0"
                                           max="100"
                                           step="0.01"
                                           (input)="limitDecimals(form, 'withdrawalFeePercent')">
                                </div>
                                <div>{{ '% of the amount obtained from energy withdrawal'|i18n }}</div>
                            </div>
                            <div class="txt-s-14-4 mt-10">
                                {{ 'Fee that the individual POD pays to the community manager.'|i18n }}
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" class="mt-50 mb-10">
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ '% of individual absorption on total absorption'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Quote in % stated in contract'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Amount in € obtained from energy withdrawal'|i18n }}
                                </div>
                                <app-icon name="fal-equals" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="txt-p-16-4 steps-panel align-center">
                                    <b>{{ 'Fee'|i18n }}</b>
                                </div>
                            </div>

                            <div fxLayoutAlign="end">
                                <button app-ghost-button [disabled]="!form.controls.withdrawalFeePercent.valid"
                                        (click)="onClickNextStep()">
                                    <app-icon name="fal-arrow-down"></app-icon>
                                    {{ 'Next step'|i18n }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- step 3 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">3</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable" (click)="goToStepIfValid(3, 'withdrawalFeePercent')">
                            {{ 'Define benefit share on energy sharing (TIP)'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 3">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-16-4 mt-30">
                                <div>{{ 'Fee specified in contract'|i18n }}:</div>
                                <div app-input-container fxFlex="10">
                                    <input app-input
                                           type="number"
                                           formControlName="tipBenefit"
                                           min="0"
                                           max="1000"
                                           step="0.01"
                                           (input)="limitDecimals(form, 'tipBenefit')">
                                </div>
                                <div>{{ '€/MWh of shared energy'|i18n }}</div>
                            </div>
                            <div class="txt-s-14-4 mt-10">
                                {{ 'Amount the individual POD receives from the community manager.'|i18n }}
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" class="mt-50 mb-10">
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ '% of individual absorption on total absorption'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Total shared energy in MWh'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Fee in €/MWh indicated per contract'|i18n }}
                                </div>
                                <app-icon name="fal-equals" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="txt-p-16-4 steps-panel align-center">
                                    <b>{{ 'Benefit'|i18n }}</b>
                                </div>
                            </div>

                            <div fxLayoutAlign="end">
                                <button app-ghost-button [disabled]="!form.controls.tipBenefit.valid" (click)="onClickNextStep()">
                                    <app-icon name="fal-arrow-down"></app-icon>
                                    {{ 'Next step'|i18n }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- step 4 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">4</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable" (click)="goToStepIfValid(4, 'tipBenefit')"
                             [innerHTML]="'Define benefit share based on ARERA self-consumption ({0})'|i18n: CACV_STRING">
                        </div>
                        <ng-container *ngIf="step === 4">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-16-4 mt-30">
                                <div>{{ 'Fee specified in contract'|i18n }}:</div>
                                <div app-input-container fxFlex="10">
                                    <input app-input
                                           type="number"
                                           formControlName="cacvBenefit"
                                           min="0"
                                           max="1000"
                                           step="0.01"
                                           (input)="limitDecimals(form, 'cacvBenefit')">
                                </div>
                                <div>{{ '€/MWh of shared energy'|i18n }}</div>
                            </div>
                            <div class="txt-s-14-4 mt-10">
                                {{ 'Percentage that the individual POD receives from the community manager.'|i18n }}
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" class="mt-50 mb-10">
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ '% of individual absorption on total absorption'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Total shared energy in MWh'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Fee in €/MWh indicated per contract'|i18n }}
                                </div>
                                <app-icon name="fal-equals" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="txt-p-16-4 steps-panel align-center">
                                    <b>{{ 'Benefit'|i18n }}</b>
                                </div>
                            </div>

                            <div fxLayoutAlign="end">
                                <button app-ghost-button [disabled]="!form.controls.cacvBenefit.valid" (click)="onClickNextStep()">
                                    <app-icon name="fal-arrow-down"></app-icon>
                                    {{ 'Next step'|i18n }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- step 5 -->
                <div fxLayout="row" fxLayoutGap="30px">
                    <div class="circle mt-20">5</div>
                    <div fxLayout="column" class="steps-panel" fxFlex>
                        <div class="txt-h-16-7 clickable" (click)="goToStepIfValid(5, 'cacvBenefit')">
                            {{ 'Define benefit share based on energy withdrawal'|i18n }}
                        </div>
                        <ng-container *ngIf="step === 5">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-p-16-4 mt-30">
                                <div>{{ 'Fee specified in contract'|i18n }}:</div>
                                <div app-input-container fxFlex="10">
                                    <input app-input
                                           type="number"
                                           formControlName="withdrawalBenefitPercent"
                                           min="0"
                                           max="100"
                                           step="0.01"
                                           (input)="limitDecimals(form, 'withdrawalBenefitPercent')">
                                </div>
                                <div>{{ '% of the amount obtained from energy withdrawal'|i18n }}</div>
                            </div>
                            <div class="txt-s-14-4 mt-10">
                                {{ 'Percentage that the individual POD receives from the community manager.'|i18n }}
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" class="mt-50 mb-10">
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ '% of individual absorption on total absorption'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Quote in % stated in contract'|i18n }}
                                </div>
                                <app-icon name="fal-asterisk" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="steps-panel txt-p-16-4  align-center">
                                    {{ 'Amount in € obtained from energy withdrawal'|i18n }}
                                </div>
                                <app-icon name="fal-equals" class="algorithm-icon"></app-icon>
                                <div fxFlex="20" class="txt-p-16-4 steps-panel align-center">
                                    <b>{{ 'Benefit'|i18n }}</b>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- save button -->
            <div fxLayout="row" fxLayoutAlign="end" class="mt-30">
                <button app-primary-button (click)="onClickSave()" fxFlex="10"
                        [disabled]="!this.form.valid || chosenAlgorithm === ALGORITHM_CONDO_OLD && step !== 5">
                    {{ 'Save'|i18n }}
                </button>
            </div>
        </div>
    </form>
</div>


<ng-template #commonAlgorithmHeader>
    <div fxLayout="row" fxLayoutAlign="center" class="txt-h-24-7">
        {{ ('Redistribution algorithm'|i18n) + ' ' + (chosenAlgorithm|redistributedAlgorithm|i18n) }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="txt-s-16-4 mt-30">
        <span>{{ ('Set up redistribution for the year'|i18n) }}</span>&nbsp;
        <b>{{ year }}</b>
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="txt-p-16-4 mt-16">
        <span>{{ ('Total POD'|i18n) + ':' }}</span>&nbsp;
        <b>{{ performanceTotalPods }}</b>
    </div>
</ng-template>


<ng-template #exceedingTip let-tipStep="tipStep">
    <div fxLayout="row" fxLayoutGap="30px" [formGroup]="form">
        <div class="circle mt-20">{{ tipStep }}</div>
        <div fxLayout="column" class="steps-panel" fxFlex>
            <div class="txt-h-16-7 clickable" (click)="onClickGoToStep(tipStep)">
                {{ 'Define how to use the exceeding amount'|i18n }}
            </div>
            <ng-container *ngIf="step === tipStep">
                <mat-radio-group formControlName="setAsideTipUsage" class="txt-p-16-4 mt-36 ml-16" fxLayout="column"
                                 fxLayoutGap="24px">
                    <mat-radio-button app-radio-button [value]="true">
                        {{ 'Set aside and do not include in redistribution'|i18n }}
                    </mat-radio-button>
                    <mat-radio-button app-radio-button [value]="false">
                        {{ 'Assign to the absorbing non companies members'|i18n }}
                    </mat-radio-button>
                </mat-radio-group>
                <div fxLayoutAlign="end">
                    <button app-ghost-button [disabled]="!form.controls.setAsideTipUsage.valid"
                            (click)="onClickNextStep()">
                        <app-icon name="fal-arrow-down"></app-icon>
                        {{ 'Next step'|i18n }}
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
